export const dialogPt = {
  header: {
    class:
      "flex items-center justify-between shrink-0 p-4 rounded-tl-lg rounded-tr-lg bg-teal-light font-bold !text-university-primary",
  },
};

export const warningPt = {
  root: {
    class: ["border-l-0", "my-4 mx-0"],
  },
  wrapper: {
    class: [
      "border",
      "border-solid",
      "border-yellow-200",
      "bg-warning-100",
      "text-yellow-800",
      "relative",
      "flex items-center",
      "py-5 px-7 rounded-md",
    ],
  },
  icon: {
    class: ["text-amber-500", "relative", "w-6 h-6", "leading-none mr-2 shrink-0", "top-[-6px]"],
  },
  text: {
    class: ["font-normal text-base leading-none"],
  },
};
